import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // at the top

import heroImage from "../assets/images/heroimg.png";
import corporateImg from "../assets/images/services/corporate-1.png";
// import Cleaning from "../assets/images/services/facade-cleaning.png";
import Industrial from "../assets/images/services/industrial-cleaning.png";
import Overseasmaid from "../assets/images/services/oversea-maid.jpg";
import AnimatedButton from "../components/AnimatedButton";
import TestimonialMarquee from "../components/Testimonials";
import checkSvg from "../assets/images/check.svg";
import aboutImg from "../assets/images/about.png";
import WhyChoose from "../assets/images/whychooseus.png";
import ClientsMarquee from "../components/ClientsMarquee";
import { fetchBlogs } from "../contentfulClient";

function Home() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    async function loadBlogs() {
      const blogData = await fetchBlogs();
      setBlogs(blogData);
    }

    loadBlogs();
  }, []);

  const stats = [
    { label: "Happy Clients", value: "75+" },
    { label: "Projects Completed", value: "1200+" },
    { label: "Years of Experience", value: "17+" },
    { label: "Team Members", value: "10+" },
  ];

  const services = [
    {
      id: 1,
      title: "Corporate Housekeeping",
      img: corporateImg,
      description1: "Daily office cleaning & sanitization.",
      description2: "Perfect for corporate spaces & work hubs.",
    },
    {
      id: 2,
      title: "Overseas Maid Services",
      img: Overseasmaid,
      description1: "Trained and verified domestic helpers for households.",
      description2:
        "Reliable support in housekeeping, childcare, and elderly care.",
    },
    {
      id: 3,
      title: "Industrial Housekeeping",
      img: Industrial,
      description1: "Heavy-duty industrial cleaning & floor care.",
      description2: "Ensures compliance & workplace safety.",
    },
  ];

  const ServicesSection = () => (
    <section className="services-grid py-5 bg-white">
      <div className="container">
        <h2 className="text-center mb-4 fw-bold">Our Services</h2>
        <div className="row text-center">
          {services.map((service) => (
            <div className="col-md-4 mb-4" key={service.id}>
              <div className="service-item">
                <img
                  src={service.img}
                  alt={service.title}
                  className="img-fluid rounded-3"
                />
                <div className="service-label">{service.title}</div>
                <p className="service-desc">{service.description1}</p>
                <p className="service-desc">{service.description2}</p>
                <Link to="/about">
                  <AnimatedButton text="Explore more" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );

  return (
    <>
      <section className="hero bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <h1 className="display-5 fw-bold lighting-text">
                Welcome to R R Facility Management Services
              </h1>
              <p>
                We provide top-notch facility management solutions dedicated to
                keeping your spaces clean, safe, and impeccably maintained, with
                a strong focus on hygiene and customer satisfaction.
              </p>
              <ul className="list-unstyled d-flex flex-wrap gap-3">
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Corporate Housekeeping
                </li>
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Office Housekeeping
                </li>
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Labour Supply Services
                </li>
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Society Housekeeping
                </li>
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Industrial Cleaning Services
                </li>
                <li>
                  <img
                    src={checkSvg}
                    className="img-fluid me-2"
                    alt="checkmark"
                  />
                  Manpower Services
                </li>
              </ul>
              <a href="/contact">
                <AnimatedButton text="Get started" />
              </a>
            </div>

            <div className="col-md-6 text-center">
              <img
                src={heroImage}
                alt="Facility Management"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </section>

      <ClientsMarquee />

      <ServicesSection />

      <section className="py-5 bg-light" id="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 mb-4 mb-md-0">
              <img
                src={aboutImg}
                alt="About R R Facility Management"
                className="img-fluid rounded"
              />
            </div>
            <div className="col-md-6">
              <h2 className="fw-bold mb-4">About Us</h2>
              <p className="text-muted">
                At <strong>R R Facility Management Services</strong>, we take
                pride in delivering professional cleaning, housekeeping, and
                facility management solutions tailored to meet your needs.
              </p>
              <p className="text-muted">
                From residential societies to commercial spaces, we provide
                reliable, efficient, and cost-effective services — making your
                comfort and satisfaction our top priority.
              </p>
              <Link to="/about">
                <AnimatedButton text="Know more" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="counters py-5 bg-dark text-center">
        <div className="container">
          <div className="row">
            {stats.map((stat, index) => (
              <div className="col-6 col-md-3 mb-4" key={index}>
                <h2 className="display-3 fw-bold text-white">{stat.value}</h2>
                <p className="mb-0 text-light">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="why-choose-us py-5 bg-light">
        <div className="container">
          <div className="mb-5">
            <h6 className="text-uppercase text-muted">Why Choose Us</h6>
            <h2 className="fw-bold">
              A simple, yet effective three-step process
            </h2>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6">
              {[
                {
                  number: "01",
                  title: "Project Idea",
                  description:
                    "We customize and ensure alignment, defining key milestones and deliverables to ensure the best solutions.",
                },
                {
                  number: "02",
                  title: "Brainstorming",
                  description:
                    "Collaboration and creativity are at the core to identify the most effective strategies.",
                },
                {
                  number: "03",
                  title: "Execution",
                  description:
                    "We implement the plan with precision, delivering high-quality outcomes on time.",
                },
              ].map((step, index) => (
                <div className="step-item d-flex mb-4" key={index}>
                  <div className="step-number">{step.number}</div>
                  <div>
                    <h5 className="mb-1 fw-bold">{step.title}</h5>
                    <p className="mb-0 text-muted">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-md-6 text-center">
              <img
                src={WhyChoose}
                alt="Why Choose Us"
                className="img-fluid rounded"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <h6 className="text-center">Our Valuable Feedbacks</h6>
        <h2 className="text-center fw-bold mb-5">What Our Clients Say</h2>
        <TestimonialMarquee />
      </section>

      {/* <section className="blog-carousel-section py-5 bg-light">
        <div className="container">
          <div className="section-header d-flex justify-content-between align-items-center mb-4">
            <h2 className="section-title fw-bold">Latest Facility Insights</h2>
            <Link to="/blogs">
              <AnimatedButton text="View All Blogs" />
            </Link>
          </div>

          <div className="row">
            {blogs.map((post, index) => (
              <div className="col-md-4 mb-4" key={post.id}>
                <div className="card blog-card h-100">
                  <div
                    className="placeholder-glow rounded"
                    style={{
                      width: "100%",
                      height: "200px",
                      backgroundColor: "#e9ecef",
                    }}
                  >
                    <img
                      src={post.image}
                      alt={post.name}
                      className="img-fluid rounded"
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="card-body">
                    <h5 className="card-title fw-bold">{post.name}</h5>
                    <p className="card-text">{post.description}</p>
                  </div>
                  <div className="card-footer border-0 bg-transparent py-3">
                    <Link to={`/blogs/${post.id}`}>
                      {" "}
                      <AnimatedButton text="Read More" className="float-end" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Home;
